export const popularSearches = [
    {
        value: 'GMP',
        label: 'GMP',
    },
    {
        value: 'Pharmacovigilance',
        label: 'Pharmacovigilance',
    },
    {
        value: 'Quality Management',
        label: 'Quality Management',
    },
    {
        value: 'Career Development',
        label: 'Career Development',
    },
    {
        value: 'Validation',
        label: 'Validation',
    },
    {
        value: 'Regulatory',
        label: 'Regulatory',
    },
    {
        value: 'Batch management',
        label: 'Batch Management',
    },
];